/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Ronnel Bedana - ronnel@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { State } from './state';
import { Stage } from './stage';
import { Client } from './client';
import { User } from './user';
import { DelayType } from './report';
import { Tag } from './tag';
import { PresetValue } from './preset-value';

export class FilterPreference {
  column: string = 'CREATED_DATE';
  isDesc: boolean = true;
  selectedStates: State[] = [];
  selectedStages: Stage[] = [];
  selectedBanks: Client[] = [];
  selectedAssignee: User[] = [];
  selectedProcessor: User[] = [];
  selectedResearchAnalyst: User[] = [];
  selectedFinancialAnalyst: User[] = [];
  selectedSeniorAnalyst: User[] = [];
  selectedDelay: DelayType = null;
  size: number = 10;
  isChanged: boolean = false;
  selectedTags: Tag[] = [];
  sliderValue: number = 3;
  showResearched: boolean = false;
  showSpreaded: boolean = false;
  selectedQuoteStates: PresetValue[] = [];
  selectedMiscs: PresetValue[] = [];

  // Report Ea
  selectedEaProcessor: User[] = [];
  selectedEaResearchAnalyst: User[] = [];
  selectedEaAppraiser: User[] = [];
  selectedEaReviewer: User[] = [];

  getStates(): string {
    return this.selectedStates.length > 0 ? this.selectedStates.map(s => s.ID).join(',') : null;
  }

  getStages(): string {
    return this.selectedStages.length > 0 ? this.selectedStages.map(s => s.ID).join(',') : null;
  }

  getAssignee(): string {
    return this.selectedAssignee.length > 0 ? this.selectedAssignee.map(u => u.ID).join(',') : null;
  }

  getProcessor(): string {
    return this.selectedProcessor.length > 0 ? this.selectedProcessor.map(u => u.ID).join(',') : null;
  }

  getResearchAnalyst(): string {
    return this.selectedResearchAnalyst.length > 0 ? this.selectedResearchAnalyst.map(u => u.ID).join(',') : null;
  }

  getFinancialAnalyst(): string {
    return this.selectedFinancialAnalyst.length > 0 ? this.selectedFinancialAnalyst.map(u => u.ID).join(',') : null;
  }

  getSeniorAnalyst(): string {
    return this.selectedSeniorAnalyst.length > 0 ? this.selectedSeniorAnalyst.map(u => u.ID).join(',') : null;
  }

  getBanks(): string {
    return this.selectedBanks.length > 0 ? this.selectedBanks.map(b => b.ID).join(',') : null;
  }

  getDelay(): string {
    return this.selectedDelay && this.selectedDelay !== null ? this.selectedDelay.toString() : null;
  }

  getTags(): string {
    return this.selectedTags.length > 0 ? this.selectedTags.map(t => t.NAME).join(',') : null;
  }

  getMics(): string {
    return this.selectedMiscs.length > 0 ? this.selectedMiscs.map(t => t.VALUE).join(',') : null;
  }

  //Report Ea
  getEaProcessor(): string {
    return this.selectedEaProcessor.length > 0 ? this.selectedEaProcessor.map(u => u.ID).join(',') : null;
  }

  getEaResearchAnalyst(): string {
    return this.selectedEaResearchAnalyst.length > 0 ? this.selectedEaResearchAnalyst.map(u => u.ID).join(',') : null;
  }

  getEaAppraiser(): string {
    return this.selectedEaAppraiser.length > 0 ? this.selectedEaAppraiser.map(u => u.ID).join(',') : null;
  }

  getEaReviewer(): string {
    return this.selectedEaReviewer.length > 0 ? this.selectedEaReviewer.map(u => u.ID).join(',') : null;
  }

  getQuoteStates(): PresetValue[] {
    return this.selectedQuoteStates.length > 0 ? this.selectedQuoteStates.map(s => s.VALUE) : null;
  }

  clear(): void {
    this.selectedAssignee = [];
    this.selectedProcessor = [];
    this.selectedResearchAnalyst = [];
    this.selectedFinancialAnalyst = [];
    this.selectedBanks = [];
    this.selectedSeniorAnalyst = [];
    this.selectedStages = [];
    this.selectedStates = [];
    this.selectedDelay = null;
    this.selectedTags = [];
    this.selectedQuoteStates = [];

    this.selectedEaProcessor = [];
    this.selectedEaResearchAnalyst = [];
    this.selectedEaAppraiser = [];
    this.selectedEaReviewer = [];

    this.showSpreaded = false;
    this.showResearched = false;
    this.selectedMiscs = [];
    /*  this.column = 'CREATED_DATE';
    this.isDesc = true;
    this.size = 10;
    this.isChanged = false; */
  }
}
